import { Draggable } from "@hello-pangea/dnd";
import { OrderRequestData } from "./Domain/RemoteOrderRequests.types";
import { Box, Card, useTheme } from "@mui/material";
import { OrderRequestCardItem } from "./partial/OrderRequestCardItem.partial";
import { ServiceType } from "../../../features/Booking-Form/typings/booking-service-administration.types";
import { isLockedOrderRequestColumn } from "./functions/orderRequestListContents.functions";

type DraggableCardItemProps = {
  item: OrderRequestData;
  index: number;
  itemIndex: number;
  filterByType: ServiceType[];
  setSelectedOrder: (o: OrderRequestData) => void;
  isArchive: boolean;
  isBookingCancelled: boolean;
};

export function DraggableCardItem({
  item,
  index,
  itemIndex,
  filterByType,
  setSelectedOrder,
  isArchive,
  isBookingCancelled
}: Readonly<DraggableCardItemProps>) {
  const theme = useTheme();

  const stylesByDragging = (isDragging: boolean) =>
    isDragging ? `3px solid ${theme.palette.primary.main}` : "none";

  return (
    <Draggable
      key={item.id}
      draggableId={String(item.id)}
      index={index}
      isDragDisabled={isLockedOrderRequestColumn(itemIndex)}
    >
      {(provided, snapshot) => (
        <Card
          sx={{
            m: "8px 16px 16px 16px",
            border: stylesByDragging(snapshot.isDragging),
            // height: 260,
            userSelect: "none",
            cursor: "no-drop"
          }}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{ ...provided.draggableProps.style }}
        >
          <Box
            data-testid={`draggable-item-${item.bookingId}`}
            onClick={() => setSelectedOrder(item)}
          >
            <OrderRequestCardItem
              item={item}
              isSelected={false}
              isDetailLoading={false}
              filterByType={filterByType}
              isArchive={isArchive}
              isBookingCancelled={isBookingCancelled}
            />
          </Box>
        </Card>
      )}
    </Draggable>
  );
}
